module.exports = __webpack_public_path__ + "img/type--4-spans--multiple-lang--fr.eba4a6b2.jpg";